var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 96,
    fill: "none",
    viewBox: "0 0 92 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A56A43",
    d: "M52.037 64.95H66.75a3.4 3.4 0 0 0 3.4-3.4v-32.3a3.4 3.4 0 0 0-3.4-3.4h-42.5a3.4 3.4 0 0 0-3.4 3.4v32.3a3.4 3.4 0 0 0 3.4 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9EAB0",
    d: "M65.9 29.25H25.1a.85.85 0 0 0-.85.85v30.6c0 .47.38.85.85.85h40.8c.47 0 .85-.38.85-.85V30.1a.85.85 0 0 0-.85-.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D25627",
    d: "M44.65 29.25h1.7v9.35h-1.7zm-2.55 0v3.544a2.55 2.55 0 0 1-.748 1.811l-3.153 3.145L37 36.551l3.145-3.153a.85.85 0 0 0 .255-.604V29.25zM54 36.552l-1.2 1.198-3.153-3.145a2.55 2.55 0 0 1-.748-1.81V29.25h1.7v3.544a.85.85 0 0 0 .255.604z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#603E26",
    d: "M33.6 45.4h-1.7a.85.85 0 0 1 0-1.7h1.7a.85.85 0 1 1 0 1.7m25.5 0h-1.7a.85.85 0 0 1 0-1.7h1.7a.85.85 0 1 1 0 1.7m-5.1 0H37a.85.85 0 0 1 0-1.7h17a.85.85 0 1 1 0 1.7m-5.1 3.4h-6.8a.85.85 0 0 1 0-1.7h6.8a.85.85 0 1 1 0 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.6 53.05h-5.1a.85.85 0 0 0-.85.85v1.7c0 .47.38.85.85.85h5.1c.47 0 .85-.38.85-.85v-1.7a.85.85 0 0 0-.85-.85m28.9 0h-5.1a.85.85 0 0 0-.85.85v1.7c0 .47.38.85.85.85h5.1c.47 0 .85-.38.85-.85v-1.7a.85.85 0 0 0-.85-.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C03A2B",
    d: "m44.88 68.265-2.202 6.596a.425.425 0 0 1-.807 0l-.765-2.287a.415.415 0 0 0-.638-.212l-1.98 1.369a.425.425 0 0 1-.646-.485l.102-.306 2.278-6.834zm5.873-2.133 2.372 7.114a.425.425 0 0 1-.646.485l-1.98-1.369a.414.414 0 0 0-.638.213l-.765 2.286a.425.425 0 0 1-.808 0l-2.193-6.588z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E64C3C",
    d: "M53.597 61.218c-.29.442-.43.966-.402 1.494a2.54 2.54 0 0 1-1.368 2.371c-.472.24-.856.623-1.098 1.094a2.52 2.52 0 0 1-2.245 1.373c-.085 0-.165-.01-.248-.01a2.5 2.5 0 0 0-1.373.406 2.51 2.51 0 0 1-2.73 0 2.5 2.5 0 0 0-1.495-.401 2.54 2.54 0 0 1-2.371-1.368 2.53 2.53 0 0 0-1.093-1.099 2.52 2.52 0 0 1-1.374-2.245c0-.084.011-.164.011-.248a2.5 2.5 0 0 0-.407-1.373 2.51 2.51 0 0 1 0-2.73c.29-.443.43-.966.401-1.495 0-.041-.005-.079-.005-.12a2.53 2.53 0 0 1 1.374-2.25c.471-.24.855-.623 1.098-1.094a2.52 2.52 0 0 1 2.245-1.373c.085 0 .165.01.248.01a2.5 2.5 0 0 0 1.373-.406 2.51 2.51 0 0 1 2.73 0 2.84 2.84 0 0 0 1.615.396 2.53 2.53 0 0 1 2.25 1.373c.24.472.623.856 1.093 1.099a2.52 2.52 0 0 1 1.374 2.245c0 .085-.012.164-.012.248a2.5 2.5 0 0 0 .408 1.372 2.51 2.51 0 0 1 0 2.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C419",
    d: "M45.5 64.95a5.1 5.1 0 1 0 0-10.2 5.1 5.1 0 0 0 0 10.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4C05C",
    d: "m31.05 29.25-6.8 6.8V30.1a.85.85 0 0 1 .85-.85zm35.7.85v5.95l-6.8-6.8h5.95a.85.85 0 0 1 .85.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C419",
    d: "M45.5 40.3a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4m-8.5-.85a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4m17 0a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 25h51v51H20z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 92,
    height: 96,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.274167 0 0 0 0 0.30731 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2001_10"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2001_10",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon2);
export default __webpack_public_path__ + "static/media/insta_icon2.86eebf0797572a987ec78fbd4bc5afa2.svg";
export { ForwardRef as ReactComponent };